app.controller('exercisesAddCtrl', ['$scope', '$rootScope', '$state', '$stateParams', '$http', '$mdDialog', '$mdMedia', '$mdToast', 'Upload', 'exerciseService', 'simulatorService',
	function ($scope, $rootScope, $state, $stateParams, $http, $mdDialog, $mdMedia, $mdToast, Upload, exerciseService, simulatorService) {

		var vm = this;

		vm.maxTimeMinutes = function() {
			var minutes = [];
			for (var i = 10; i <= 60; i += 5) {
				minutes.push(i);
			}
			return minutes;
		}

		vm.schoolCategories = [
			{ value: 1, name: "4. - 6. klasse" },
			{ value: 2, name: "7. - 10. klasse" },
			{ value: 3, name: "Ungdomsuddannelser"}
		];

		var tivoliCenter = [12.5680196, 55.6737266];

		vm.form = {};
		vm.submitting = false;

		vm.model = {
			schoolCategory: 1,
			number: 0,
			name: "",
			description: "",
			imageUrl: null,
			timeMinutes: 5,
			teacherInfoShortText: "",
			teacherInfoLongText: "",
			mapPos: tivoliCenter,
			mapText: "",
			goalsText: "",
			goals: ["", "", "", ""],
			questions: [],
			evaluationQuestions: [],
		};

		vm.exercise = null;
		vm.loaded = true;
		if ($stateParams.id) {
			vm.loaded = false;
			exerciseService.get($stateParams.id).then(function(exercise) {
				if (exercise) {
					vm.model = exercise;
					vm.exercise = exercise;

					if (vm.model.teacherInfoShortText == null) {
						vm.model.teacherInfoShortText = "";
					}

					if (vm.model.teacherInfoLongText == null) {
						vm.model.teacherInfoLongText = "";
					}

					if (!vm.model.questions) {
						vm.model.questions = [];
					}

					if (!vm.model.evaluationQuestions) {
						vm.model.evaluationQuestions = [];
					}

					for (var i = 0; i < vm.model.questions.length; i++) {
						var q = vm.model.questions[i];
						q.index = i;
						q.hidden = true;
					}

					for (var i = 0; i < vm.model.evaluationQuestions.length; i++) {
						var q = vm.model.evaluationQuestions[i];
						q.index = i;
						q.hidden = true;
					}

					vm.loaded = true;
				}
			});
		}

		vm.hideQuestion = function(question) {
			question.hidden = true;
		}

		vm.showQuestion = function(question) {
			question.hidden = false;
		}

		vm.addQuestion = function(container, evt) {
			evt.preventDefault();

			var questionObj = {
					index: container.length,
					hidden: true,
					text: "",
					extraButtonText: "",
					extraHtml: "",
					answers: [
						{
							index: 0,
							text: "",
							wrongAnswerText: "",
							correct: false,
						},
						{
							index: 1,
							text: "",
							wrongAnswerText: "",
							correct: false,
						},
						{
							index: 2,
							text: "",
							wrongAnswerText: "",
							correct: false,
						},
						{
							index: 3,
							text: "",
							wrongAnswerText: "",
							correct: false
						}
					]
				}
			container.push(questionObj);
		}

		vm.listOrderChanged = function(container) {
			$scope.$apply(function() {
				for (var i = 0; i < container.length; i++) {
					container[i].index = i;
				}
			});	
		}

		vm.removeQuestion = function(container, question, evt) {
			evt.preventDefault();

        	var confirm = $mdDialog.confirm()
	            .title('Fjern spørgsmål?')
	            .textContent('Er du sikker på at du vil fjerne spørgsmålet?')
	            .ariaLabel('Fjern spørgsmål')
	            .targetEvent(evt)
	            .ok('Fjern')
	            .cancel('Anullér');
        	$mdDialog.show(confirm).then(function () {
				var newQuestions = [];
				for (var i = 0; i < container.length; i++) {
					var iterQuestion = container[i];
					if (question == iterQuestion) {
						continue;
					}
					newQuestions.push(iterQuestion);
				}

				// Remove & re-add
				while (container.length > 0) {
					container.pop();
				}
				for (var i = 0; i < newQuestions.length; i++) {
					var newQ = newQuestions[i];
					newQ.index = i;
					container.push(newQ);
				}
			});
		}

		vm.uploading = false;
		vm.upload = function (file) {
			if (file == null) {
				return;
			}

			FD.BlobToDataURL(file).then(function(dataUrl) {
				vm.model.imageUrl = dataUrl;
			});
        }

        vm.removeImage = function(evt) {
        	evt.preventDefault();

        	var confirm = $mdDialog.confirm()
	            .title('Fjern billede?')
	            .textContent('Er du sikker på at du vil fjerne dette billede?')
	            .ariaLabel('Fjern billede')
	            .targetEvent(evt)
	            .ok('Fjern')
	            .cancel('Anullér');
        	$mdDialog.show(confirm).then(function () {
				vm.model.imageUrl = null;
			});
        }

		vm.map = new maptalks.Map('maptalksc', {
        	center: vm.model.mapPos,
        	zoom: 16.64,
        	bearing: 150.0,
        	attribution: false,

	        //allow map to drag pitching, true by default
        	dragPitch : false,
        	//allow map to drag rotating, true by default
        	dragRotate : true,
        	//enable map to drag pitching and rotating at the same time, false by default
        	dragRotatePitch : false,

        	baseLayer: new maptalks.TileLayer('base', {
          		urlTemplate: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
          		subdomains: ['a','b','c','d'],
          		attribution: ''
        	})
      	});

		var center = vm.map.getCenter();
		vm.mapOverlayLayer = new maptalks.VectorLayer('vector').addTo(vm.map);

        // Add the go-to pos
      	vm.targetMarker = new maptalks.Marker(
      		vm.model.mapPos,
        	{
	          	'symbol' : {
	            	'markerFile'   : window.location.origin + '/img/map/MapPin.svg',
	            	'markerWidth'  : 2*22,
	            	'markerHeight' : 2*35.5,
	            	'markerDx'     : 0,
	            	'markerDy'     : 0,
	            	'markerOpacity': 1
	          	}
	    	}
      	);
      	vm.targetMarker.addTo(vm.mapOverlayLayer);

      	vm.map.on('click', function(evt) {
      		$scope.$apply(function() {
	      		vm.targetMarker.setCoordinates(evt.coordinate);
	       		vm.model.mapPos = [evt.coordinate.x, evt.coordinate.y];
	      	});
      	});

      	$scope.$watch('vm.model.mapPos', angular.bind(vm, function() {
      		vm.targetMarker.setCoordinates(vm.model.mapPos);
      	}), true);

      	vm.resetMap = function() {
      		vm.map.setCenter(tivoliCenter);
      		vm.map.setZoom(16.64);
      		vm.map.setBearing(150.0);
      	}

		vm.previewQuestion = function(exercise, questionIndex, evt) {
			evt.preventDefault();

			simulatorService.showWithExercise(exercise, questionIndex);
      	}

       	vm.save = function () {
        	// Ensure timeMinutes is an int.
        	if (vm.model.timeMinutes) {
        		vm.model.timeMinutes = parseInt(vm.model.timeMinutes);
        	}

            if (!vm.form.$valid)
                return;
            vm.submitting = true;

            if (vm.exercise) {
            	vm.model.id = vm.exercise.id; // XXX
	            $http.post('api/exercise', vm.model, {headers: {'Content-Type': 'application/json'}})
	                .then(function (resp) {
	                    $mdToast.show(
	                        $mdToast.simple()
	                        .textContent("Opgave opdateret")
	                        .position('top right')
	                        .hideDelay(3000)
	                    );
	                    $state.go('exercises.details', {'id': resp.data.id}, { reload: true });
	                }, function (err) {
	                    vm.submitting = false;
	                    if (err.status === 409) {
	                        vm.form.name.$setValidity("taken", false);
	                    }
	                });
            } else {
	            $http.put('api/exercise', vm.model, {headers: {'Content-Type': 'application/json'}})
	                .then(function (resp) {
	                    $mdToast.show(
	                        $mdToast.simple()
	                        .textContent("Opgave tilføjet")
	                        .position('top right')
	                        .hideDelay(3000)
	                    );
	                    $state.go('exercises.details', {'id': resp.data.id}, {reload: true});
	                }, function (err) {
	                    vm.submitting = false;

	                    if (err.status === 409) {
	                        vm.form.name.$setValidity("taken", false);
	                    }
	                });
	        }
        }
	}
]);